import { useEffect, useMemo, useState } from 'react';
import { api } from '../api';
import PageHeader from '../components/PageHeader';
import OrderMonthGroups from '../components/OrderMonthGroups';
import OrdersToolbar from '../components/OrdersToolbar';
import ReportExportBar from '../components/ReportExportBar';
import { filterOrders, sortOrders, groupOrdersByMonth } from '../utils/orderUtils';
import { runDispatchedReportExport } from '../utils/reportExports';

export default function DispatchedOrders() {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [customFrom, setCustomFrom] = useState('');
  const [customTo, setCustomTo] = useState('');
  const [sortBy, setSortBy] = useState('newest');

  const load = () =>
    api
      .getOrders('Dispatched')
      .then(setOrders)
      .catch((e) => setError(e.message));

  useEffect(() => {
    load();
    const interval = setInterval(load, 5000);
    return () => clearInterval(interval);
  }, []);

  const filtered = useMemo(() => {
    const f = filterOrders(orders, { search, dateFilter, customFrom, customTo });
    return sortOrders(f, sortBy);
  }, [orders, search, dateFilter, customFrom, customTo, sortBy]);

  const groups = useMemo(() => groupOrdersByMonth(filtered), [filtered]);

  return (
    <div>
      <PageHeader
        title="Dispatched Orders"
        subtitle="Shipped orders grouped by month"
      />
      {error && <p className="text-red-600 mb-4">{error}</p>}

      <OrdersToolbar
        search={search}
        onSearchChange={setSearch}
        dateFilter={dateFilter}
        onDateFilterChange={setDateFilter}
        customFrom={customFrom}
        customTo={customTo}
        onCustomFromChange={setCustomFrom}
        onCustomToChange={setCustomTo}
        sortBy={sortBy}
        onSortChange={setSortBy}
      />

      <OrderMonthGroups groups={groups} />

      <ReportExportBar
        onExport={(params) => runDispatchedReportExport({ ...params, orders })}
      />
    </div>
  );
}
